// extracted by mini-css-extract-plugin
export default {"productGallery":"GI-z","inQuickShop":"HI-z"};